var map = {
	"./cuarto creciente.svg": "a769",
	"./cuarto menguante.svg": "be9f",
	"./luna creciente.svg": "c0bc",
	"./luna gibosa creciente.svg": "747f",
	"./luna gibosa menguante.svg": "46dd",
	"./luna llena.svg": "9d16",
	"./luna menguante.svg": "b46f",
	"./luna nueva.svg": "5d02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "364d";